import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoGridOneColumn,
    RaikoButtonSecondary, RaikoFlexFirstChildGrowOne
} from "@moeindal/base-raiko-panel-components";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {RouteHelper} from "../../../route/RouteHelper";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabBoxContainer from "../../../component/tabBoxContainer/TabBoxContainer";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import LoanDetailBasicInfo from "./LoanDetailBasicInfo";
import LoanReceiptDetail from "./loanReceiptDetail/LoanReceiptDetail";
import LoanDetailReports from "./LoanDetailReports";
import LoanDetailDeleteLoan from "./LoanDetailDeletLoan";

export default function LoanDetail() {

    const {state: location} = useLocation()
    const {id: loanId} = useParams()

    const navigate = useNavigate()

    const [pageTitle, setPageTitle] = useState()

    const [receiptUrl, setReceiptUrl] = useState("");

    useEffect(() => {
        if (location && location.title) {
            setPageTitle(`${location.title} (${loanId})`)
        }
    }, [location]);


    const [selectedTab, setSelectedTab] = useState(tabInfo.BASIC_INFO.id)

    const handleChangeTabMenu = (event, newValue) => {
        setSelectedTab(newValue)
    }


    return (
        <RaikoBaseContainer>
            <RaikoFlexFirstChildGrowOne>
                <RaikoBreadcrumb className={css`flex-grow: 1;
                  gap: .5rem;`} breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.LoansList.name,
                        RouteHelper.LoansList.globalUrl
                    ),
                    raikoBreadCrumbItemGenerator(
                        pageTitle,
                        ""
                    )
                ]}/>

                <RaikoButtonSecondary
                    label={"بازگشت"}
                    onClick={_ => {
                        navigate(-1);
                    }}/>
            </RaikoFlexFirstChildGrowOne>


            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <TabContext value={selectedTab}>
                    <TabBoxContainer>
                        <TabList onChange={handleChangeTabMenu} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={tabInfo.BASIC_INFO.title}
                                value={tabInfo.BASIC_INFO.id}
                            />
                            <Tab
                                label={tabInfo.LOAN_RECEIPT.title}
                                value={tabInfo.LOAN_RECEIPT.id}
                            />
                            <Tab
                                label={tabInfo.LOAN_REPORT.title}
                                value={tabInfo.LOAN_REPORT.id}
                            />
                            <Tab
                                label={tabInfo.LOAN_DELETE.title}
                                value={tabInfo.LOAN_DELETE.id}
                            />
                        </TabList>
                    </TabBoxContainer>
                    <TabPanel value={tabInfo.BASIC_INFO.id}>
                        <LoanDetailBasicInfo setReceiptUrl={setReceiptUrl}/>
                    </TabPanel>
                    <TabPanel value={tabInfo.LOAN_RECEIPT.id}>
                        <LoanReceiptDetail receiptUrl={receiptUrl}/>
                    </TabPanel>
                    <TabPanel value={tabInfo.LOAN_REPORT.id}>
                        <LoanDetailReports/>
                    </TabPanel>
                    <TabPanel value={tabInfo.LOAN_DELETE.id}>
                        <LoanDetailDeleteLoan/>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>

    )
}

const tabInfo = {
    BASIC_INFO: {
        id: "BASIC_INFO",
        title: "اطلاعات پایه"
    }, LOAN_RECEIPT: {
        id: "LOAN_RECEIPT",
        title: "رسید پرداخت"
    }, LOAN_REPORT: {
        id: "LOAN_REPORT",
        title: "گزارشات"
    }, LOAN_DELETE: {
        id: "LOAN_DELETE",
        title: "حذف وام"
    },
}
